<div class="fc-organization-information">
    <ng-container *ngIf="!(organizationLookupCompleted | async)">
        <p class="fc-organization-information-description">{{ 'SIGNUP.ORGANIZATION_INFO.DESCRIPTION' | translate }}</p>
    </ng-container>
    <form
        [formGroup]="organizationForm"
        name="organizationForm"
        role="form"
        (ngSubmit)="submitOrganization(organizationForm)"
        novalidate
        class="fc-organization-information-form"
    >
        <div class="fc-organization-information-body">
            <div class="fc-organization-information-item-wrapper">
                <label for="organizationName">
                    {{
                        (organizationType === 'retailer'
                            ? 'SIGNUP.ORGANIZATION_INFO.ORGANIZATION_NAME.RETAILER'
                            : 'SIGNUP.ORGANIZATION_INFO.ORGANIZATION_NAME.MANUFACTURER'
                        ) | translate
                    }}
                </label>
                <fcp-dropdown
                    id="organizationName"
                    [title]="
                        (organizationType === 'retailer'
                            ? 'SIGNUP.ORGANIZATION_LOOKUP.DROPDOWN.RETAILER_PLACEHOLDER'
                            : 'SIGNUP.ORGANIZATION_LOOKUP.DROPDOWN.MANUFACTURER_PLACEHOLDER'
                        ) | translate
                    "
                    [items]="organizationLookupResult | async"
                    [autoComplete]="true"
                    (searchQueryChange)="onSearchQueryChange($event, 'organizationName')"
                    (ngModelChange)="onOrganizationNameChange($event)"
                    formControlName="organizationName"
                    data-e2e-hook="organization-name"
                ></fcp-dropdown>
            </div>

            <ng-container *ngIf="organizationLookupCompleted | async">
                <div class="fc-organization-information-item-wrapper">
                    <label for="organizationLine1">{{ 'ADDRESSLINE_1' | translate }}</label>

                    <fcp-form-field
                        [isInvalid]="isFieldInvalid(organizationForm, 'organizationLine1')"
                        [width]="'fluid'"
                    >
                        <input
                            id="organizationLine1"
                            fcpInput
                            formControlName="organizationLine1"
                            [placeholder]="'SIGNUP.FORM.PLACEHOLDER.ADDRESS1' | translate"
                            data-e2e-hook="organization-address"
                        />
                        <span fcpFieldError>{{
                            getErrorTranslationKey(
                                organizationForm,
                                'organizationLine1',
                                'SIGNUP.FORM.VALIDATION.ADDRESS1'
                            ) | translate
                        }}</span>
                    </fcp-form-field>
                </div>

                <div class="fc-organization-information-item-wrapper">
                    <label for="organizationCountry">{{ 'SIGNUP.FORM.PLACEHOLDER.COUNTRY' | translate }}</label>
                    <fcp-dropdown
                        id="organizationCountry"
                        class="fc-guest-panel-form-field"
                        [title]="
                            organizationForm.value.organizationCountry?.label || 'SIGNUP.FORM.PLACEHOLDER.COUNTRY'
                                | translate
                        "
                        [items]="countries | async"
                        (searchQueryChange)="onSearchQueryChange($event, 'country')"
                        formControlName="organizationCountry"
                        errorMessage="{{ 'SIGNUP.FORM.VALIDATION.COUNTRY' | translate }}"
                        data-e2e-hook="country"
                    ></fcp-dropdown>
                </div>

                <div class="fc-zip-panel-form-group fc-organization-information-item-wrapper">
                    <label for="organizationCity">
                        {{ 'SIGNUP.FORM.PLACEHOLDER.CITY' | translate }}

                        <fcp-form-field
                            [isInvalid]="isFieldInvalid(organizationForm, 'organizationCity')"
                            [width]="'fluid'"
                        >
                            <input
                                id="organizationCity"
                                fcpInput
                                formControlName="organizationCity"
                                [placeholder]="'SIGNUP.FORM.PLACEHOLDER.CITY' | translate"
                                data-e2e-hook="city"
                            />
                            <span fcpFieldError>{{
                                getErrorTranslationKey(
                                    organizationForm,
                                    'organizationCity',
                                    'SIGNUP.FORM.VALIDATION.CITY'
                                ) | translate
                            }}</span>
                        </fcp-form-field>
                    </label>

                    <label for="organizationZip"
                        >{{ 'SIGNUP.FORM.PLACEHOLDER.ZIP' | translate }}

                        <fcp-form-field
                            [isInvalid]="isFieldInvalid(organizationForm, 'organizationZip')"
                            [width]="'fluid'"
                        >
                            <input
                                id="organizationZip"
                                fcpInput
                                formControlName="organizationZip"
                                [placeholder]="'SIGNUP.FORM.PLACEHOLDER.ZIP' | translate"
                                data-e2e-hook="zip-code"
                            />
                            <span fcpFieldError>{{
                                getErrorTranslationKey(
                                    organizationForm,
                                    'organizationZip',
                                    'SIGNUP.FORM.VALIDATION.ZIP'
                                ) | translate
                            }}</span>
                        </fcp-form-field>
                    </label>
                </div>

                <div class="fc-organization-information-item-wrapper">
                    <label for="organizationPhone">{{ 'SIGNUP.FORM.PLACEHOLDER.PHONE' | translate }}</label>

                    <fcp-form-field
                        [isInvalid]="isFieldInvalid(organizationForm, 'organizationPhone')"
                        [width]="'fluid'"
                    >
                        <input
                            id="organizationPhone"
                            fcpInput
                            formControlName="organizationPhone"
                            [placeholder]="'SIGNUP.FORM.PLACEHOLDER.PHONE' | translate"
                            data-e2e-hook="phone"
                        />
                        <span fcpFieldError>{{
                            getErrorTranslationKey(
                                organizationForm,
                                'organizationPhone',
                                'SIGNUP.FORM.VALIDATION.PHONE'
                            ) | translate
                        }}</span>
                    </fcp-form-field>
                </div>
                <div *ngIf="!referralId" class="fc-organization-information-item-wrapper">
                    <label for="signupReason">{{ 'SIGNUP.FORM.PLACEHOLDER.SIGNUP_REASON' | translate }}</label>

                    <fcp-form-field [width]="'fluid'">
                        <input
                            id="signupReason"
                            fcpInput
                            formControlName="signupReason"
                            [placeholder]="
                                (organizationType === 'retailer'
                                    ? 'SIGNUP.FORM.PLACEHOLDER.SIGNUP_DESCRIPTION_RETAILER'
                                    : 'SIGNUP.FORM.PLACEHOLDER.SIGNUP_DESCRIPTION_BRANDS'
                                ) | translate
                            "
                            data-e2e-hook="signup-reason"
                        />
                    </fcp-form-field>
                </div>
            </ng-container>
        </div>
        <div class="fc-organization-information-footer">
            <button
                fcp-filled-button
                [size]="'large'"
                [disabled]="organizationForm.invalid"
                type="submit"
                class="fc-finish-signup-signin"
                data-e2e-hook="signup-request-next-step"
            >
                {{ 'SIGNUP.BUTTONS.NEXT' | translate }}
            </button>
            <button
                *ngIf="showPrevButton || (organizationLookupCompleted | async)"
                type="button"
                fcp-outlined-button
                (click)="onBackClicked()"
                class="fc-finish-signup-button"
                [size]="'large'"
            >
                {{ 'SIGNUP.BUTTONS.PREV' | translate }}
            </button>
        </div>
    </form>
</div>
